import React, { useState, useEffect } from 'react';
import Modal from '../../components/Modal';

export default function DeleteSaleModal({ isOpen, onClose, onConfirm, saleId }) {
  const [restoreStock, setRestoreStock] = useState(true);

  // Resetar checkbox quando o modal abrir
  useEffect(() => {
    if (isOpen) {
      setRestoreStock(true);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(restoreStock);
  };

  const title = (
    <div style={{
      background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
      margin: '-24px -24px 0 -24px',
      padding: '24px',
      borderRadius: '12px 12px 0 0',
      borderBottom: '2px solid rgba(255, 255, 255, 0.1)'
    }}>
      <h2 style={{
        margin: '0',
        color: '#ffffff',
        fontSize: '24px',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <i className="fas fa-exclamation-triangle" style={{ fontSize: '22px' }} />
        Cancelar Venda
      </h2>
    </div>
  );

  const footer = (
    <>
      <button
        onClick={onClose}
        type="button"
        style={{
          background: 'rgba(255, 255, 255, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          color: '#b0b0b0',
          padding: '10px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.12)';
          e.target.style.color = '#d0d0d0';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.08)';
          e.target.style.color = '#b0b0b0';
        }}
      >
        Fechar
      </button>
      <button
        onClick={handleConfirm}
        type="button"
        style={{
          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
          border: 'none',
          color: '#ffffff',
          padding: '10px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(220, 53, 69, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 15px rgba(220, 53, 69, 0.3)';
        }}
      >
        Sim, cancelar venda
      </button>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer}>
      <p style={{
        margin: '0 0 20px 0',
        color: '#b0b0b0',
        fontSize: '15px',
        lineHeight: '1.6'
      }}>
        Deseja realmente cancelar esta venda?
      </p>
      
      <div style={{
        background: 'rgba(242, 146, 5, 0.1)',
        borderRadius: '8px',
        padding: '16px',
        border: '1px solid rgba(242, 146, 5, 0.3)',
        marginBottom: '20px'
      }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          cursor: 'pointer',
          color: '#ffffff',
          fontSize: '14px',
          fontWeight: '500',
          userSelect: 'none'
        }}>
          <input
            type="checkbox"
            checked={restoreStock}
            onChange={(e) => setRestoreStock(e.target.checked)}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer',
              accentColor: '#f29205'
            }}
          />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '600', marginBottom: '4px' }}>
              Reverter estoque dos produtos?
            </div>
            <div style={{ 
              fontSize: '12px', 
              color: 'rgba(255, 255, 255, 0.7)',
              lineHeight: '1.4'
            }}>
              {restoreStock 
                ? 'Os produtos serão devolvidos ao estoque automaticamente.'
                : 'Os produtos não serão devolvidos ao estoque. Use esta opção se os produtos já foram utilizados ou não podem ser devolvidos.'}
            </div>
          </div>
        </label>
      </div>

      <div style={{
        background: 'rgba(220, 53, 69, 0.15)',
        borderRadius: '8px',
        padding: '16px',
        border: '1px solid rgba(220, 53, 69, 0.4)',
        marginBottom: '24px'
      }}>
        <p style={{
          margin: '0',
          color: '#ff8888',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: '500'
        }}>
          <i className="fas fa-info-circle" />
          Esta ação não pode ser desfeita.
        </p>
      </div>
    </Modal>
  );
}




